<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-poet">
<h1>About the Poet</h1>
<p style="text-indent:00em;">I’m the sleepiest girl to walk this Earth,</p>
<p style="text-indent:00em;">while you’re all out enjoying your mirth.</p>
<p style="text-indent:00em;">I sit and ponder what it would be like,</p>
<p style="text-indent:00em;">to sit late with drinks or go and hike.</p>
<p style="text-indent:00em;">“So why don’t you?” you say, and all the while,</p>
<p style="text-indent:00em;">I sigh, look down, give a knowing smile:</p>
<p style="text-indent:00em;">“Last year, I had brain surgeries – three,</p>
<p style="text-indent:00em;">so I’m not like you and you aren’t like me.</p>
<p style="text-indent:00em;">It’s not that I don’t want the fullest of lives,</p>
<p style="text-indent:00em;">it’s because I fear the pain of those stabbing knives</p>
<p style="text-indent:00em;">that I know I’ll feel if I don’t get my sleep,</p>
<p style="text-indent:00em;">you’ll be out and me? I won’t make a peep.</p>
<p style="text-indent:00em;">I used to be like you, you see,</p>
<p style="text-indent:00em;">but now I’m not like you and you aren’t like me.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?f3b8141e